// extracted by mini-css-extract-plugin
var _1 = "AnnotationForm_buttons__11eb3";
var _2 = "AnnotationForm_root__b009f";
export { _1 as "buttons", _2 as "root" }
